module.exports = __webpack_public_path__ + "d97ce4c22e9059466c84bb0dfb10c9a0.png";